import { welcomeScreenUnlockedKey } from "../constants";

const isUnlocked = () => {
  return localStorage.getItem(welcomeScreenUnlockedKey) === "true";
};

export const checkUnlocked = isUnlocked;
